import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import { vfmPlugin } from 'vue-final-modal'
import './assets/css/jquery-ui.css';    //globally available in all components!
import 'nprogress/nprogress.css';
import LineSeparator from './components/LineSeparator.vue';
 
createApp(App)
    .component('LineSeparator', LineSeparator)
    .use(vfmPlugin({    //https://vue-final-modal.org/ per finestre modali
        key: '$vfm',
        componentName: 'VueFinalModal',
        dynamicContainerName: 'ModalsContainer'
    }))
    .use(store)
    .use(router)
    .mount("#app-scheda");
